import { actions } from "@grandvisionhq/state";
const unlinkOrder = actions.action(
  "auth/orders/unlink",
  actions.payload()
);
const unlinkOrderSuccess = actions.action("auth/orders/unlink-success");
const unlinkOrderFailed = actions.action(
  "auth/orders/unlink-failed",
  (error) => ({
    error
  })
);
export {
  unlinkOrder,
  unlinkOrderFailed,
  unlinkOrderSuccess
};
//# sourceMappingURL=actions.js.map
